import {
    Trash2
} from 'lucide-react';
import {
    RecordsCell
} from './RecordsCell';
import {
    Button
} from 'shared/components/ui/button';
import {
    Tooltip, TooltipContent, TooltipProvider, TooltipTrigger
} from 'shared/components/ui/tooltip';
import {
    Checkbox
} from 'shared/components/ui/checkbox';
import {
    TableCell as UITableCell
} from 'shared/components/ui/table';

// Define the types for props
import {
 Column,Row
} from './types/builderRecords.types';

interface RecordsRowProps {
    row: Row;
    columns: Column[];
    hiddenColumns: string[];
    isSelected: boolean;
    onCellChange: (rowId: string, columnName: string, value: any, dataType: string) => void;
    onCellBlur: (rowId: string, columnName: string, value: any) => void;
    onDeleteRow: (rowId: string) => void;
    onSelectRow: (rowId: string) => void;
    updatedRows: Row[];
    isAddingNewRecord: boolean;
    hiddenFields?: string[];
    tableId?: string | null;
}

export function RecordsRow({
    row,
    columns,
    hiddenColumns,
    isSelected,
    onCellChange,
    onCellBlur,
    onDeleteRow,
    onSelectRow,
    updatedRows,
    isAddingNewRecord,
    hiddenFields = ['null'],
    tableId = null
}: RecordsRowProps) {
    const isModified = updatedRows?.some((r) => r.id === row.id);
    const isDraft = row?.isDraft;

    const readOnlyFields = [
        'modifiedBy',
        'modifiedOn',
        'recordId',
        'recordStatus',
        'createdBy',
        'createdOn'
    ];

    return (
        <tr className={`group hover:bg-muted/30 ${isDraft ? 'bg-yellow-50 border-l-2 border-l-yellow-400' : ''} ${isModified ? 'bg-blue-50' : ''}`}>
            <UITableCell className="w-[50px] p-0">
                <div className="flex items-center justify-center h-full">
                    <Checkbox
                        checked={isSelected}
                        onCheckedChange={() => onSelectRow(row.id)}
                        aria-label={`Select row ${row.id}`}
                    />
                </div>
            </UITableCell>
            {columns
                .filter((column) => !hiddenColumns.includes(column.columnName))
                .map((column) => {
                    const isReadOnly = readOnlyFields.includes(column.columnName);
                    const ishidden = hiddenFields.includes(column.columnName);

                    if (ishidden) return null;

                    return (
                        <RecordsCell
                            key={`${row.id}-${column.columnName}`}
                            row={row}
                            column={column}
                            value={row[column.columnName]}
                            onChange={(value) => onCellChange(row.id, column.columnName, value, column.dataType)}
                            onBlur={(value) => onCellBlur(row.id, column.columnName, value)}
                            disableEditing={isReadOnly || (isAddingNewRecord && !isDraft)}
                        />
                    );
                })}

            <UITableCell className="w-[100px]">
                <div className="flex items-center justify-end space-x-1">
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="icon"
                                    onClick={() =>
                                        tableId === 'User'
                                            ? onDeleteRow(row.user_id)
                                            : onDeleteRow(row.id)
                                    }
                                    className="h-8 w-8 opacity-0 group-hover:opacity-100 hover:opacity-100 text-muted-foreground hover:text-destructive"
                                >
                                    <Trash2 className="h-4 w-4" />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>Delete record</TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </div>
            </UITableCell>
        </tr>
    );
}
